/* eslint-disable no-unused-vars */
export var AuthorizedMessage;
(function (AuthorizedMessage) {
    AuthorizedMessage["LEFT"] = "g";
    AuthorizedMessage["RIGHT"] = "d";
    AuthorizedMessage["UNSUPPORTED"] = "UNSUPPORTED";
    AuthorizedMessage["SUGGEST_CLEAVAGE"] = "c";
    AuthorizedMessage["HELP"] = "help";
    AuthorizedMessage["SHORT_HELP"] = "h";
    AuthorizedMessage["SHORT_APPLAUSE"] = "a";
    AuthorizedMessage["SHORT_SHOOT"] = "s";
    AuthorizedMessage["SHORT_HYPERLIKE"] = "l";
    AuthorizedMessage["SHORT_WHISTLE"] = "w";
})(AuthorizedMessage || (AuthorizedMessage = {}));
